import React from 'react'

import _ from 'lodash'

import Link from '@Pure/Link'

const moment = window.moment;

moment.locale('fr');

export let form =
{
	model: 'ECMeetingRecord'.toLowerCase(),

	form_title: 'Compte rendu de réunion',

	fields:
	{
		text:
		{
			label: 'Texte',
			type: 'editor'
		},

		date:
		{
			type :'date',
			label: 'Date'
		},

		pdfs:
		{
			type: 'pdf',
			multiple: true,
			label: 'PDFs à joindre'
		}
	},

	create_label: 'Créer ce compte rendu',

	get__deleteModalText: function (form_data)
	{
		let msg = form_data['ecmeetingrecord[date]']
		? moment(form_data['ecmeetingrecord[date]']).format('DD MMMM YYYY')
		: undefined;

		let output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer
					{
						msg
						? ' le compte rendu de réunion du'
						: ' ce compte rendu de réunion ?'
					}
				</p>

				{
					msg ?
					(
						<div className="u-center">

							<div className="name-in-modal">

								{ msg }

							</div>

						</div>
					)
					: undefined
				}

			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		let output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Un nouveau compte rendu de réunion daté au <strong> { moment(model.date).format('dddd DD MMMM YYYY') } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/accueil/mon-espace/comptes-rendus-de-reunion/' + model.id }>
						Voir le compte rendu
					</Link>
				</div>
			</div>
		);

		return output;
	}
}

export let list =
{
	model         : 'ECMeetingRecord'.toLowerCase(),
	title         : 'Liste des comptes rendus de réunion',
	link          : '/accueil/mon-espace/comptes-rendus-de-reunion',
	creation_link : '/accueil/mon-espace/nouveau-compte-rendu-de-reunion',
	creation_label: 'Déposer un nouveau compte rendu',

	header_map:
	{
		'Date': 'date'
	},

	field_hook:
	{
		'Date': function (value)
		{
			return window.moment(value).format('dddd DD MMMM');
		}
	},

	row_link_base: '/accueil/mon-espace/comptes-rendus-de-reunion/',
	searched_prop: 'date',

	sort: function (records)
	{
		return records.sort((a, b) => moment(a).isAfter(b) ? -1 : 1);
	}
};

let config = _.cloneDeep(form);

export default _.merge(config, list);